<template>
  <div class="form-container">
    <form-fields
      ref="register"
      :fields="fields"
      :error="error"
      :is-big="true"
      @on-change-field="handleChangeField"
      @on-submit="handleRegister">
      <div v-if="isNotAcceptable" slot="after-field-email" class="paragraph-s alternate-register">
        <div @click="alternateRegisterClick" v-html="alternateHtml"></div>
      </div>
    </form-fields>
    <slot name="after-fields-form"></slot>
    <div class="field field-center">
      <terms-conditions-label :button-name="labels.signUp" />
    </div>
    <b-field>
      <div class="sign-up-btn-wrapper" @click="onSignUpBtnClick()">
        <button
          :ref="signUpBtn"
          :disabled="disabled"
          :class="{ 'is-loading': loading }"
          class="button is-primary button-submit"
          @click="handleRegister">
          {{ labels.signUp }}
        </button>
      </div>
    </b-field>


  </div>
</template>

<script>

import FormFields from 'top20common/components/form/FormFields';

import TermsConditionsLabel from './TermsConditionsLabel';

export default {
  props: {
    fields: Array,
    error: Object,
    loading: Boolean,
    disabled: Boolean,
    handleChangeField: Function,
    handleRegister: Function
  },
  data() {
    return {
      signUpBtn: 'sign-up-button'
    };
  },
  computed: {
    alternateHtml() {
      return this.$gettext('If you are a candidate, you can find opportunities <a class="link">here</a>');
    },
    isNotAcceptable() {
      return Boolean(this.error && this.error.statusCode === 406);
    },
    labels() {
      return {
        signUp: this.$gettext('Sign up')
      };
    }
  },
  methods: {
    alternateRegisterClick(event) {
      if (event.target.tagName.toLowerCase() !== 'a') {
        return;
      }
      this.$router.push({name: 'register-candidate'});
    },
    onSignUpBtnClick() {
      this.$emit('sign-up-click', this.$refs[this.signUpBtn].disabled);
    }
  },
  components: {TermsConditionsLabel, FormFields}
};
</script>

<style lang="scss" scoped>
.sign-up-btn-wrapper {
  display: inline-block;
}
.sign-up-btn-wrapper,
.button-submit {
  width: 100%;
}

.field-center {
  display: flex;
  align-items: center;
  -webkit-align-items: center;
}
.alternate-register {
  color: var(--secondary);
  /deep/ a.link {
    text-decoration: underline;
  }
}
</style>
